import {
  getItemOrDefaultToValue,
  getPersonName,
  getPhoneNumber,
} from 'utils/details';
import { displayTime } from 'utils/time';
import { DEFAULT_EMPTY_VALUE } from '../../constants';
import {
  getDestination,
  getVisitPurpose,
} from 'utils/DataTransform/Visitor/VisitorList';

const getVisitorImage = data => {
  const photoImageObj = {
    value: getItemOrDefaultToValue(data, 'photoUrl', null),
  };

  if (data.photoUrl && data.identificationUrl) {
    return [
      {
        value: getItemOrDefaultToValue(data, 'photoUrl', null),
      },
      { value: getItemOrDefaultToValue(data, 'identificationUrl', null) },
    ];
  }

  return data.photoUrl
    ? photoImageObj
    : { value: getItemOrDefaultToValue(data, 'identificationUrl', null) };
};

export const transformVisitorDetails = ({ data, timeZone }) => {
  const { visitor, signerIn, signerOut, purpose, destination } = data;
  return {
    generalInfo: {
      passId: {
        type: 'text',
        label: 'Pass ID',
        value: data.passName || DEFAULT_EMPTY_VALUE,
      },
      siteName: {
        type: 'text',
        value: getItemOrDefaultToValue(data, 'siteName', DEFAULT_EMPTY_VALUE),
      },
      visitorType: {
        type: 'text',
        value: visitor.visitorType ? visitor.visitorType : DEFAULT_EMPTY_VALUE,
      },
      firstName: {
        type: 'text',
        value: getItemOrDefaultToValue(
          visitor,
          'firstName',
          DEFAULT_EMPTY_VALUE,
        ),
      },
      lastName: {
        type: 'text',
        value: getItemOrDefaultToValue(
          visitor,
          'lastName',
          DEFAULT_EMPTY_VALUE,
        ),
      },
      company: {
        type: 'text',
        value: visitor
          ? visitor.company || DEFAULT_EMPTY_VALUE
          : DEFAULT_EMPTY_VALUE,
      },
      email: {
        type: 'text',
        value: getItemOrDefaultToValue(visitor, 'email', DEFAULT_EMPTY_VALUE),
      },
      phone: {
        type: 'text',
        value: getPhoneNumber(visitor.phone, DEFAULT_EMPTY_VALUE),
      },
      vehicleRegistration: {
        type: 'text',
        label: 'visitor_vehicle_registration_key',
        value: getItemOrDefaultToValue(
          visitor,
          'vehicleRegistration',
          DEFAULT_EMPTY_VALUE,
        ),
      },
      signInTime: {
        type: 'text',
        label: 'Sign in time',
        value: displayTime({ timestamp: data.accessTime, timeZone }),
      },
      purpose: {
        type: 'text',
        label: 'visitor_purpose_key',
        value: getVisitPurpose(purpose),
      },
      destination: {
        type: 'text',
        value: getDestination(destination),
      },
      signOutTime: {
        type: 'text',
        label: 'Sign out time',
        value: data.egressTime
          ? displayTime({ timestamp: data.egressTime, timeZone })
          : DEFAULT_EMPTY_VALUE,
      },
      notes: {
        type: 'text',
        value: getItemOrDefaultToValue(data, 'notes', DEFAULT_EMPTY_VALUE),
      },
    },
    multiDetailGeneralInfo: [
      {
        signedInBy: {
          type: 'text',
          label: 'Signed in by',
          value: getPersonName(signerIn, DEFAULT_EMPTY_VALUE),
        },
        employeeId: {
          type: 'text',
          label: 'Employee ID',
          value: getItemOrDefaultToValue(
            signerIn,
            'employeeId',
            DEFAULT_EMPTY_VALUE,
          ),
        },
        role: {
          type: 'text',
          value: getItemOrDefaultToValue(signerIn, 'roles', []).join(', '),
        },
        securityCompanyName: {
          type: 'text',
          label: 'Company Name',
          value: getItemOrDefaultToValue(
            signerIn,
            'securityCompanyName',
            DEFAULT_EMPTY_VALUE,
          ),
        },
        photoUrl: {
          value: getItemOrDefaultToValue(signerIn, 'photoUrl'),
        },
      },
      {
        ...(data.egressTime && {
          signedOutBy: {
            type: 'text',
            value: getPersonName(signerOut, DEFAULT_EMPTY_VALUE),
          },
          employeeId: {
            type: 'text',
            value: getItemOrDefaultToValue(
              signerOut,
              'employeeId',
              DEFAULT_EMPTY_VALUE,
            ),
          },
          role: {
            type: 'text',
            value: getItemOrDefaultToValue(signerOut, 'roles', []).join(', '),
          },
          securityCompanyName: {
            type: 'text',
            value: getItemOrDefaultToValue(
              signerOut,
              'securityCompanyName',
              DEFAULT_EMPTY_VALUE,
            ),
          },
          photoUrl: { value: getItemOrDefaultToValue(signerOut, 'photoUrl') },
        }),
      },
    ],
    others: {
      id: data.id,
      image: getVisitorImage(visitor),
      detailedInfoImage: {
        value: getItemOrDefaultToValue(signerIn, 'photoUrl'),
      },
    },
  };
};
